import { runTextWrapBalance } from './lib/text-wrap-balance.js';
import { runCTATracking } from './lib/resize-cta-tracking.js';
import { ajaxForms } from './lib/ajax-forms.js';
import { stickyElements } from './lib/sticky-elements.js';
import { apiSidebarAccordion } from './lib/api-sidebar-accordion.js';
import { customGAEvents } from './lib/custom-ga-events.js';
import { signalsLoadMore } from './lib/signals-load-more.js';
import { signalsFilterScroll } from './lib/signals-filter-scroll.js';
import { tableOfContents } from './lib/table-of-contents.js';
import { signalSidebar } from './lib/signal-sidebar.js';

jQuery(document).ready(function () {
  runTextWrapBalance();
  runCTATracking();
  ajaxForms();
  stickyElements();
  apiSidebarAccordion();
  signalsLoadMore();
  signalsFilterScroll();
  signalSidebar();
  tableOfContents();

  setTimeout(function () {
    customGAEvents();
  }, 3000);

  // Sticky Header
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 0) {
      $('header').addClass('site-header--sticked-top');
    } else {
      $('header').removeClass('site-header--sticked-top');
    }
  });

  // Site Navigation Overflow Stopped on Navbar Toggle
  const siteNavigationId = 'site-navigation';
  $(`#${siteNavigationId}`).on('show.bs.collapse', function (e) {
    if (e.target.id !== siteNavigationId) {
      return;
    }
    $('body').addClass('overflow-stopped');
    // $('.site-header .nav-wrapper').css('height', $(window).height() - 60 + 'px');
    // document.documentElement.style.setProperty("--body-height", );
  }).on('hide.bs.collapse', function (e) {
    if (e.target.id !== siteNavigationId) {
      return;
    }

    $('body').removeClass('overflow-stopped');
    // $('.site-header .nav-wrapper').css('height', 'auto');
  });

  (function () {
    // Stores context of the active tab
    $('.how-dmc-used a[data-toggle="tab"]').on('show.bs.tab', function (e) {
      window.localStorage.setItem('dmc_used_active_tab', $(e.target).attr('href'));
    });

    // Restore context to the lastly active tab
    var activeTab = window.localStorage.getItem('dmc_used_active_tab');

    if (activeTab) {
      $('#dmc-uses a[href="' + activeTab + '"]').tab('show');
    }
  })();

  var $dmcUsesToggle = $('.how-dmc-used .dropdown .nav-link.active').text();
  $('.how-dmc-used .dropdown .dmc-uses-toggle').text($dmcUsesToggle);

  $(".dropdown-menu li a").click(function () {
    var parent = $(this).closest('.dropdown');
    parent.find(".btn:first-child").text($(this).text());
    parent.find(".btn:first-child").val($(this).text());
  });

  // Open intercom chat widget
  $("a[href='#open-chat']").on('click', function () {
    Intercom('show');
  });

  $("ul.navbar-nav li.dropdown").on("touchenter mouseover", function (e) {
    // do hover start code
    if ($('.tablet-media-query').is(':visible')) {} else {
      $(this).addClass('show');
      $(this).find('.dropdown-menu').addClass('show');
      $(this).find('.dropdown-toggle').attr("aria-expanded", "true");
    }
  }).on("touchleave mouseleave", function (e) {
    // do hover end code
    if ($('.tablet-media-query').is(':visible')) {} else {
      $(this).find('.dropdown-menu').removeClass('show');
      $(this).find('.dropdown-toggle').attr("aria-expanded", "false");
      $(this).removeClass('show');
    }
  });

  // handle .total-customers--pull-up
  $('.total-customers--pull-up').each(function (i, section) {
    var $section = $(section);
    var $prevSection = $(section).prev();

    if ($prevSection.length) {
      $prevSection.addClass('total-customers--prev');
    }
  });

   function mobileOnlySlider() {
      $('.new-slider').slick({
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 1000,
          dots: true,
          autoplaySpeed: 5000
      });
  }
  if(window.innerWidth <= 768) {
      mobileOnlySlider();
  }

  $(window).resize(function(e){
      if(window.innerWidth < 768) {
          if(!$('.new-slider').hasClass('slick-initialized')){
              mobileOnlySlider();
          }

      }else{
          if($('.new-slider').hasClass('slick-initialized')){
              $('.new-slider').slick('unslick');
          }
      }
  });
  // Hero Flyer
  $('.organizations-icons ul').each(function (i, slider) {
    var $slider = $(slider);

    $slider.slick({
      speed: 4000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: $slider.data('slide-count') < 6 ? $slider.data('slide-count') : 6,
      infinite: true,
      swipeToSlide: true,
      centerMode: true,
      focusOnSelect: true,
      arrows: false,
      rows: 0,
      adaptiveHeight: false,
      responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            speed: 2000,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            speed: 2000,
          }
        }
      ]
    });
  });

  // Latest Blogs Slider
  $('.latest-blogs .blogs-slider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerPadding: '40px',
    arrows: true,
    dots: false,
    rows: 0,
    responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '50px',
        }
      }
    ]
  });

  $('.slider-mobile').each(function (e) {
    var $section = $(this);

    if ($section.hasClass('list-mobile') || $section.hasClass('notification-type--ai-receptionist')) {
      $section.find('.slider-controls').hide();
    } else {
      var $groups = $section.find('.slider-mobile-group');

      if ($groups.length) {
        $groups.each(function () {
          mobileSlider($(this).find('.slider-mobile__init').first());
        });
      } else {
        mobileSlider($section.find('.slider-mobile__init'));
      }
    }
  });

  $('.company-qualities').each(function (e) {
    if ($(this).hasClass('list-mobile')) {
      $(this).find('.slider-controls').hide();
    } else {
      var slider = $(this).find('.slider-mobile');
      mobileSlider(slider);
    }
  });

  $('.input--auto-tab').on('input change', function () {
    inputAutoTab(this, $(this).closest('span').next().children('input')[0]);
  });

  // Custom click for Slick Sliders
  $(document).on('click', '.custom-arrow', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $group = $this.closest('.slider-mobile-group');
    var $slider = $group.length
      ? $group.find('.slick-initialized').first()
      : $this.closest('.has-slider,.slider-mobile').find('.slick-initialized').first();

    if (!$slider.length) {
      return;
    }

    if ($this.is('.custom-arrow--right')) {
      $slider.slick('slickNext')
    } else {
      $slider.slick('slickPrev')
    }
  });

  // Switch image on hover on feature hover
  $('.industries-wrap li').on('mouseenter', function () {
    var $this = $(this).find('a');
    var imageURL = $this.data('image');
    var $imageContainer = $this.closest('section').find('.broadcast-thumbnail');

    if (imageURL == $imageContainer.data('current-image-url')) {
      return false;
    }

    $imageContainer.fadeOut('fast', function () {
      $imageContainer.data('current-image-url', imageURL).css('background-image', 'url(' + imageURL + ')');
      $imageContainer.fadeIn('fast');
    });
  });

  $('.industries-wrap li').on('click', function () {
    $('.industries-wrap li').removeClass('tapped');
    $(this).addClass('tapped');
  });

  // Testimonials Custom SLider
  $('.testimonials-slider-init').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    rows: 0,
    fade: true,
    speed: 800,
    cssEase: 'linear',
    adaptiveHeight: true
  });

  // How it works accordion for mobile
  $(document).on('click', '.accordion-sm .accordion-title', function (e) {
    e.preventDefault();
    if ($('.mobile-media-query').is(':visible')) {
      var $parent = $(this).closest(".accordion-sm");

      if ($parent.is(".active")) {
        $parent.find(".accordion-content").slideUp();
        $parent.removeClass("active");
      } else {
        $parent.find(".accordion-content").slideDown();
        $parent.addClass("active");
      }
    } else {}
  });

  // How IT Works Accordion
  $('.broadcast-accordion .accordion-title').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.closest('.accordion-item');
    var $section = $this.closest('section');

    if ($parent.hasClass('active')) {
      $parent.find('.accordion-content').slideUp();
      $parent.removeClass('active');
    } else {
      var imageURL = $parent.attr('data-image');
      var $tabtitle = $parent.attr('data-title');
      var $thumbnail = $section.find('.accordion-thumbnail img');
      var $thumbnailSource = $section.find('.accordion-thumbnail source');
      var $activetitle = $section.find('.accordion-thumbnail .active-heading');
      $thumbnail.fadeOut('fast', function () {
        if ($thumbnailSource.length !== 0) {
          $thumbnailSource.attr('srcset', imageURL);
        }
        $thumbnail.attr('src', imageURL).fadeIn('fast');
        $activetitle.html($tabtitle);
      });

      $section.find('.accordion-item.active').removeClass('active').find('.accordion-content').slideUp();
      $parent.addClass('active').find('.accordion-content').slideDown();
    }
  });

  $('.accordion .accordion-title').on('click', function (e) {
    e.preventDefault();
    var $parent = $(this).closest('.accordion-item');
    var wasActive = $parent.hasClass('active');

    $parent.closest('.accordion').find('.accordion-item.active').removeClass('active').find('.accordion-content').slideUp();

    if (wasActive) return;

    $parent.addClass('active').find('.accordion-content').slideDown();
  });

  $(".faqs-page-wrapper .links-wrap [href^='#']").on('click', function () {
    id = $(this).attr("href");
    $('html, body').animate({
      scrollTop: $(id).offset().top - 130
    }, 900);
  });

  $('.btn-wrap a[href^="#"]').each(function () {
    const modalId = $(this).attr('href');

    if (modalId && modalId !== '#') {
      const $modal = $(modalId);

      if ($modal.length && $modal.hasClass('modal')) {
        $(this)
          .attr('data-toggle',  'modal')
      }
    }
  });

  $('.btn-wrap a[href^="#"]').on('click', function () {
    var modalId = $(this).attr('href');

    if (modalId == '#') {
      return;
    }

    var $modal = $(modalId);

    // check whether the modal exist
    if ($modal.length && $modal.first().hasClass('modal')) {
      $(this).attr('data-toggle', 'modal');
    }
  });

  $(".api-function [href^='#']").on('click', function () {
    id = $(this).attr("href");

    $('html, body').animate({
      scrollTop: $("a[href='" + id + "']").offset().top - 130
    }, 900);
  });

  // Update email field in form # 2
  // on changing email in form # 1
  $(document).on('change keyup', '#form-rfi-1 input[type="email"]', function () {
    $('#form-rfi-2 input[type="email"]').attr('value', this.value);
  });

  $('.modal').on('hidden.bs.modal', function (e) {
    $(this).find('form').trigger('reset');
    $(this).find('.dmcform').hide();
  });

  $('form.shortSignupForm').on('submit', function (e) {
    e.preventDefault();
    var $form = $(this);
    var $actionURL = $(this).data('action');
    var isValid = true;
    // hide all errors
    $form.find('.fieldset__error').hide();

    var $email = $form.find('input[type=email]');
    var $password = $form.find('input[type=password]');
    var $emailError = $email.prev();
    var $passwordError = $password.prev();
    var email = $email.val();
    var password = $password.val();

    if (!email.length || !validateEmail(email)) {
      // email is empty
      isValid = false;

      // report the error
      $emailError.text('Please enter an email address.').show();

      // focus in the input element
      $email.focus();
    } else if (!password.length) {
      // password is empty
      isValid = false;

      // report the error
      $passwordError.text('Please enter a password.').show();

      // focus in the input element
      $password.focus();
    }

    if (isValid) {
      var e = $(this);
      return $.post($actionURL + '/ajax/signup.php', e.serialize(), function (e) {
        if ("ok" == e.result) {
          window.dataLayer = window.dataLayer || [];

          dataLayer.push({
            'event': 'onboarding',
            'onboarding_step': 'signup',
            'user_email': $email,
          });
          
          window.location = e.url
        } else { 
          alert(e.error_msg)
        }
      }, "json");
    }
  });

  // add smooth scroll to a[data-scroll]
  $('a[data-scroll]').on('click', function (evt) {
    evt.preventDefault();
    $('a[data-scroll]').removeClass('active');
    $(this).addClass('active');
    var href = $(this).attr('href').split('#')[1];
    scrollToPos('#' + href, 115);
  });

  if (typeof window.IMask === 'function') {
    $('[data-mask-pattern]').each(function (i, input) {
      window.IMask(input, {
        mask: this.dataset.maskPattern
      });
    });
  }
  
});


jQuery(window).on('load', function () {
  var $counters = $('.number-count-up');

  setInterval(function () {
    $counters.each(function (i, counter) {
      var number = parseInt(counter.dataset.number) + 1;
      counter.innerHTML = numberWithCommas(number);
      counter.dataset.number = number;
    });
  }, 1000);

  $(window).on('resize orientationchange', function () {
    stickyElements();

    $('.hero .hero__bottom ul').slick('resize');
    $('.latest-blogs .blogs-slider').slick('resize');
    $('.company-qualities .slider-mobile').slick('resize');
    $('.slider-mobile .slider-mobile__init').slick('resize');
    window.rangeSliderWidth = $('.tab-pane__inner__top').width();
  });
});

function numberWithCommas(x) {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

function scrollToPos(target, offset) {
  if (target == '#') {
    $('html, body').animate({
      scrollTop: 0
    }, 1000);
  } else {
    $('html, body').animate({
      scrollTop: $(target).offset().top - offset
    }, 1000);
  }
}

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase())
}

function mobileSlider(slider) {
  // Company Qualities Slider
  $(slider).slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '50px',
    arrows: true,
    dots: false,
    responsive: [{
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });
}

(function () {
  var lazyVideos = document.querySelectorAll('.lazy-video');

  for (var i = 0; i < lazyVideos.length; i++) {
    var image = new Image();
    image.src = lazyVideos[i].dataset.thumbnail;

    image.addEventListener('load', function () {
      lazyVideos[i].appendChild(image);
    }(i));

    lazyVideos[i].addEventListener('click', function () {
      var iframe = '';
      var host = this.dataset.host;

      if (host == 'youtube' || host == 'vimeo') {
        iframe = document.createElement('iframe');

        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('webkitallowfullscreen', '');
        iframe.setAttribute('mozallowfullscreen', '');
        iframe.setAttribute('src', this.dataset.embed);
      } else {
        // render html5 video
        iframe = document.createElement('video');
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('controls', '');

        var source = document.createElement('source');
        source.setAttribute('src', this.dataset.embed);
        source.setAttribute('type', 'video/' + this.dataset.embed.split('.').pop());

        iframe.innerText = 'Your browser does not support HTML5 video.';
        iframe.append(source);
      }


      this.innerHTML = '';
      this.appendChild(iframe);
    });
  };
})();

function inputAutoTab(currentInput, targetInput) {
  if (currentInput.value.length == currentInput.maxLength && targetInput != null) {
    targetInput.focus();
  }
}
